import React, { Component } from 'react';
import { Alert } from 'reactstrap';
import { Link } from 'react-router-dom';


class MessageItem extends Component {
  
  constructor(props) {
    super(props);
    this.onDismiss = this.onDismiss.bind(this);
    this.state = {
      isOpen: true
    }
  }
  
  onDismiss() {
    if (this.props.toggle && typeof this.props.toggle === 'function'){
      return this.props.toggle(this.props.message)
    }
    else{
      return this.setState({isOpen: !this.state.isOpen});
    }
  }
  
  render() {
    const { color, message, pinned, activate_btn } = this.props;
    const showActivateBtn = activate_btn// && process.env.NODE_ENV !== 'production';
    
    return (
      <Alert color={color} isOpen={this.state.isOpen} toggle={!pinned && this.onDismiss}>{message}{showActivateBtn && <Link to="/upgrade" className="btn btn-white btn-sm" style={{marginLeft: '1.5em'}}>Activate Now!</Link>}</Alert>
    )
  }
}

export default MessageItem;


// WEBPACK FOOTER //
// ./src/components/notifications/MessageItem.js